import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class RoomTypeService {
  static getRoomType(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getRoomType}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getRoomType}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addRoomType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addRoomType}`;
    return axiosInstance
        .post(api,item)
        
}

static editRoomType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editRoomType}`;
    return axiosInstance
        .put(api,item)
        
}


static getRooms(item = {}) {
    const params = new URLSearchParams();

    if (item.id) {
        params.append('id', item.id);
    }

    if (item.hotelId) {
        params.append('hotelId', item.hotelId);
    }

    if (item.limit) {
        params.append('limit', item.limit);
    }

    const api = `${API_BASE_URL}${API_PATHS.getRoom}?${params.toString()}`;

    return axiosInstance.get(api);
}



static addRooms(item) {

  let api = '';
  api = `${API_BASE_URL}${API_PATHS.addRoom}`;
  return axiosInstance
      .post(api,item)
      
}

static editRooms(item) {

  let api = '';
  api = `${API_BASE_URL}${API_PATHS.editRoom}`;
  return axiosInstance
      .put(api,item)
      
}


static getAvailability(item) {
  
    let api = '';
    if(item?.id){
       api= `${API_BASE_URL}${API_PATHS.getAvailability}?id=${item?.id}`
    }
    else
    if(item?.roomId){
        api= `${API_BASE_URL}${API_PATHS.getAvailability}?roomId=${item?.roomId}`
     } else{
    api = `${API_BASE_URL}${API_PATHS.getAvailability}?limit=${item?.limit}`;
    }
    return axiosInstance
        .get(api)
        
}


static addAvailability(item) {

  let api = '';
  api = `${API_BASE_URL}${API_PATHS.addAvailability}`;
  return axiosInstance
      .post(api,item)
      
}

static editAvailability(item) {

  let api = '';
  api = `${API_BASE_URL}${API_PATHS.editAvailability}`;
  return axiosInstance
      .put(api,item)
      
}



  
}

export default RoomTypeService;